import { useMutation } from '@tanstack/react-query';
import type { RequestAccountDeletionDto } from '@nomiss/sdk';
import { requestAccountDeletion } from '@nomiss/services';

export const useRequestAccountDeletion = () => {
  const requestAccountDeletionMutation = useMutation({
    mutationFn: (data: RequestAccountDeletionDto) => requestAccountDeletion(data),
  });

  return { requestAccountDeletionMutation };
};
